import { Position } from '@src/main/modules/parameters/domain/fleet-positions/position.interface';
import { PositionRepository } from '@src/main/modules/parameters/domain/fleet-positions/position.repository';

export const findAllPositions = async (repository: PositionRepository): Promise<Position[]> =>
  await repository.findAll();
